import { getQueue } from './queue';

export const track = (data: any) => {
    data.type = 'track';

    return enqueue('/t', data);
};

export const page = (data: any) => {
    data.type = 'page';

    return enqueue('/p', data);
};

export const identify = (data: any) => {
    data.type = 'identify';

    return enqueue('/i', data);
};

export const enqueue = (path: string, message: any) => {
    const url = `/ps-fnl-events/api/data${path}`;

    const queue = getQueue();
    queue.addItem({
        url,
        message,
    });
};

export default {
    track,
    page,
    identify,
};
